// extracted by mini-css-extract-plugin
module.exports = {"main":"Slider_main__2PlYM","label":"Slider_label__Me7TY","container":"Slider_container__163UF","slider":"Slider_slider__393xn","rangeValue":"Slider_rangeValue__3ePjc"};